import {postRequest,getRequest,putRequest} from '../../../actions/Axios'
import {GET_ALL_CONTAB_ACTION,SET_SEARCH_CONTAB_ACTION,SELECT_FILTER_OPTION_CONTAB_ACTION,FILTER_CONTAB_ACTION,SET_ADD_CONTAB_ACTION_MODAL_OPEN,SET_ADD_CONTAB_ACTION_MODAL_CLOSE,
    TOOGLE_DRAWER_CONTAB_ACTION} from '../../../../constants/ActionTypes'




    export  const addActionContab=(params,body,CallBack)=>(dispatch)=>{
        dispatch(postRequest("/ContabAction",params,body))
        .then(resp=>{
            const {payload:{data,status}}=resp;
            CallBack(data,status)
        }).catch(error=>console.log(error));
    }   

    export  const updateActionContab=({Id},body,CallBack)=>(dispatch)=>{
    dispatch(putRequest(`/ContabAction/${Id}`,{},{ ...body,Id}))
    .then(resp=>{
        const {payload:{data,status}}=resp;
        CallBack(data,status)
    }).catch(error=>console.log(error));
    }

    export const GetContabAction=()=>(dispatch)=>{

        dispatch(getRequest("/ContabAction/GetAllContabAction",{}))
        .then(resp=>{
            const {payload:{data}}=resp;
    
            dispatch({
                type:GET_ALL_CONTAB_ACTION,
                payload:data
            })
        }).catch(error=>console.log(error));
    }

    export const setSearchContabAction=(seachText)=>{
        return{
            type:SET_SEARCH_CONTAB_ACTION,
            payload:seachText
        }
    }
    

    export const selectOptionActionContab=(optionId)=>{  

        return{
            type:SELECT_FILTER_OPTION_CONTAB_ACTION,
            payload:optionId
        }
    }

    export const filterContabActionData=()=>{
        return {
            type:FILTER_CONTAB_ACTION
        }
    }


    export const  addContabActionModalOpen =()=>({
        type:SET_ADD_CONTAB_ACTION_MODAL_OPEN,
        payload:true
    })

    export const  addContabActionModalClose =()=>({
            type:SET_ADD_CONTAB_ACTION_MODAL_CLOSE,
            payload:false
    })

export const toogleDrawerContabAction=()=>({
    type:TOOGLE_DRAWER_CONTAB_ACTION
})
  
